<template>
	<b-row>
		<b-col cols="12">
			<div id="parentx">
				<transition name="slide">
					<b-card>
						<div slot="header">
							{{ $t('contract.contracts') }}
							<div class="card-header-actions">
								<b-link
									@click="newCont(null, 'create')"
									class="card-header-action btn-setting"
									style="font-size: 15px"
									v-if="$can('create', 'item')"
								>
									<i class="fa fa-plus-circle"></i>
								</b-link>



							</div>
						</div>
						<b-card-body>

							<!-- TABLE -->
							<div class="table-responsive table-wrapper">
								<b-table
									striped
									hover
									:items="items"
									:fields="refField"
									:current-page="search.limit"
									:per-page="0"
									bordered="bordered"
									show-empty
									class="generalTableClass"
								>
									<template slot="completed" slot-scope="data" class="col-md-8">

										<b-badge variant="success" v-if="data.item.completed === true">{{  $t('words.yes') }}</b-badge>
										<b-badge variant="danger" v-else>{{  $t('words.no') }}</b-badge>

									</template>
									<template slot="type" slot-scope="data" class="col-md-8">

										<b-badge variant="secondary" v-if="data.item.type === 'PUL_BERILADI'">{{  data.item.type }}</b-badge>
										<b-badge variant="dark" v-else>{{  data.item.type }}</b-badge>

									</template>

									<template slot="stageName" slot-scope="data" class="col-md-8">

										<b-badge variant="primary" v-if="data.item.stageName === 'Boshlandi'">	{{ data.item.stageName}}</b-badge>
										<b-badge variant="warning" v-else-if="data.item.stageName === 'Ko\'rib chiqilmoqda'">	{{ data.item.stageName}}</b-badge>
										<b-badge variant="success" v-else>	{{ data.item.stageName}}</b-badge>

									</template>

									<template slot="actions" slot-scope="data">
										<b-link
											@click="openCreate(data.item, 'edit')"
											:title="$t('Edit')"
											v-if="$can('edit', 'item')"

										>
											<i class="fa fa-edit"></i>
										</b-link>
										<b-link :key="data.item.id + 'delete'"
												@click="closeOthers(data.item.id)"
												:id="'popOverDelete'+data.item.id"
												v-if="$can('delete', 'item')"
										>
											<i class="fa fa-trash"></i>
										</b-link>
										<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
										<b-popover
											:key="data.item.id + 'popover'"
											:target="'popOverDelete'+data.item.id"
											placement="auto"
											container="myContainer"
											:ref="'popover'+data.item.id"
											class="refDeleteConfirm"
										>
											<template slot="title">
												<b-button @click="onClose(data.item.id)" class="close" aria-label="Close"
														  style="margin-left: 5px">
													<span class="d-inline-block" aria-hidden="true">&times;</span>
												</b-button>
												{{$t('actions.deletetitle')}}
											</template>

											<div>
												<!--<b-link @click="onClose" size="sm" variant="danger">Yo'q</b-link>
                                                <b-link @click="onOk" size="sm" variant="primary">Ha</b-link>-->
												<div class="row mt-1">
													<div class="col-6">
														<b-button variant="outline-danger" size="sm" block
																  @click="deletePopover(data.item.id)">{{$t('actions.no')}}
														</b-button>
													</div>
													<div class="col-6">
														<b-button variant="outline-success" size="sm" block
																  @click="remove(data.item.id)">{{$t('actions.yes')}}
														</b-button>
													</div>
												</div>
											</div>
										</b-popover>
										<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->

									</template>


								</b-table>
								<div v-if="loader" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</div>
							<!-- TABLE -->


							<nav>
								<b-pagination :total-rows="total" :per-page="search.limit" v-model="search.page"
											  :prev-text="$t('pagination.prev')"
											  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
							</nav>

						</b-card-body>
					</b-card>
				</transition>
				<vs-sidebar :click-not-close="true" position-right parent="body" default-index="1" color="primary"
							class="create-modal" spacer v-model="newContract">
					<b-container index="1" v-if="newContract">
						<add-contract @success="reloadList()"
										 @not-close="closable = $event"
										 @close="close"
										 :mode="mode"
										 :edit="item"
						></add-contract>
					</b-container>
				</vs-sidebar>
			</div>
		</b-col>
	</b-row>
</template>

<script>

	import AddContract from './blocks/AddContract'
	import {mapActions, mapState, mapGetters} from "vuex";

	export default {
		name: 'Contracts',

		data: () => {
			return {
				mode:'create',
				loader: true,
				item: null,
				refField: [],
				newContract: false,
				search: {
					page: 1,
					limit: 20,
					attributes: []
				}
			};
		},


		/**
		 * Computed
		 */
		created () {
			document.title = 'Contracts'
			this.allContracts(this.search)
			this.refField = this.filterColumns(this.columns)
			this.loader  = false
		},
		computed: {
			...mapGetters('contract',{
				items: 'getAllContracts',
				columns: 'columns',
				total: 'getTotal'

			}),

		},

		methods: {
			...mapActions('contract',['allContracts','deleteContract']),

			// Close new promo modal
			close() {
				this.newContract = false;
				this.mode = 'create';
				this.item = null;
			},


			newCont(item = null, mode = 'create') {
				this.item = item;
				this.mode = mode;
				setTimeout(() => {
					this.newContract = true
				}, 100);
			},

			reloadList() {
				setTimeout(() => {
					this.allContracts(this.search)
				}, 200);
				this.newContract = false;

			},
			filterColumns(columns = []) {
				return columns.filter(column => {
					if (column.visible) {
						column.label = this.$t(column.label);
						return column
					}
				})
			},
			openCreate(item = null, mode = 'create') {
				this.item = item
				this.mode = mode;
				setTimeout(() => {
					this.newContract = true
				}, 100);
			},
			onClose(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('close')
			},
			deletePopover(index) {
				const refName = `popover${index}`;
				this.$refs[refName].$emit('close')
			},
			closeOthers(id) {
				Object.keys(this.$refs).map(key => {
					if (key !== `popover${id}`) {
						const refName = `popover${id}`;
						this.$refs[refName].$emit('close')
					}
				});
			},
			remove(id) {
				this.deleteContract(id)
				this.reloadList();
			},
		},


		mounted(){

		},
		watch:{
			'search.page': {
				handler() {
					this.allContracts(this.search)
				}
			},
		},
		/**
		 * components
		 */
		components: {
			AddContract
		},


	}
</script>

<style scoped>
	.table-wrapper {
		position: relative;
		padding: 5px;
	}

	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}
</style>
